module.exports = __webpack_public_path__ + "static/media/blåbærsyltetøy.f9db1de9.mp3";